/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const featureAboutMeConfig = {
  title: 'Bharat Life Saral Jeevan Bima',
  image: 'https://i.ibb.co/02wVzNz/bharat-life-insurance-v2.png',
  useOfProceedsDetail: {
    title: 'Use of Proceeds',
  },
};
